if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      static STORAGE_KEY = 'decency:recently-viewed';
      static MAX_STORED = 20;

      connectedCallback() {
        this.list = this.querySelector('[data-recently-viewed-list]');
        this.currentHandle = this.dataset.productHandle || '';
        this.limit = parseInt(this.dataset.limit, 10) || 4;

        const history = this.readHistory();
        const handlesToShow = history.filter((handle) => handle !== this.currentHandle).slice(0, this.limit);

        if (this.currentHandle) this.saveHistory(history);
        if (handlesToShow.length > 0) this.renderProducts(handlesToShow);
      }

      readHistory() {
        try {
          const stored = JSON.parse(window.localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY) || '[]');
          return Array.isArray(stored) ? stored.filter((handle) => typeof handle === 'string') : [];
        } catch (error) {
          return [];
        }
      }

      saveHistory(history) {
        const updated = [this.currentHandle, ...history.filter((handle) => handle !== this.currentHandle)].slice(
          0,
          RecentlyViewedProducts.MAX_STORED
        );
        try {
          window.localStorage.setItem(RecentlyViewedProducts.STORAGE_KEY, JSON.stringify(updated));
        } catch (error) {
          // Storage can be unavailable (private browsing); the section simply stays hidden.
        }
      }

      async renderProducts(handles) {
        const root = (this.dataset.rootUrl || '/').replace(/\/$/, '');
        const sectionId = this.dataset.sectionId;

        const cards = await Promise.all(
          handles.map(async (handle) => {
            try {
              const response = await fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=${sectionId}`);
              if (!response.ok) return null;
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const template = html.querySelector('template[data-recently-viewed-card]');
              return template ? template.content.cloneNode(true) : null;
            } catch (error) {
              return null;
            }
          })
        );

        const found = cards.filter(Boolean);
        if (found.length === 0) return;

        this.list.replaceChildren(...found);
        this.querySelector('[data-recently-viewed-note]')?.remove();
        this.hidden = false;

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(this);
      }
    }
  );
}
